import { action, atom } from '@reatom/framework'

import { goBackAction } from '@root/features/routing/atoms'

import { syncQueryParamWithMakerReaction } from './reatom-trades-table'

export const chartHeightAtom = atom<number>(
  typeof window === 'undefined' ? 120 : window.innerHeight * 0.65,
  'chartHeightAtom',
)

export const handleBackAction = action((ctx) => {
  goBackAction(ctx)
}, 'handleBackAction')

export const initializeTradePageAction = action((ctx) => {
  syncQueryParamWithMakerReaction(ctx)
}, 'initializeTradePageAction')
